import React from 'react';
import styles from './FeedListInfinitySpinner.module.scss';

interface PersonProps {
  isLoadingMore: boolean;
}

export const FeedListInfinitySpinner: React.FC<PersonProps> = (isLoadingMore) => {
  return (
    <>
      {isLoadingMore ? (
        <div className={styles.fadeIn}>
          <div className={styles.container}>
            <div className={styles.spinner}>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
